import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "react-toastify";

import { login, getUserDetails } from "../api/auth";
import { api } from "../api";
import { setToken, setUser, setRegion, setSwitchRegion } from "../redux/authSlice";

const LoginImage = "/images/login-logo.png";

const LoginForm = () => {
  const token = useSelector((state) => state.auth.token);
  const region = useSelector((state) => state.auth.region);
  const user = useSelector((state) => state.auth.user);

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [otp, setOtp] = useState("");
  const [showOTPForm, setShowOTPForm] = useState(false);
  const [tempToken, setTempToken] = useState(null);
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [resendAvailable, setResendAvailable] = useState(false);
  const [timer, setTimer] = useState(60);
  const [resendAttempts, setResendAttempts] = useState(0);

  const startTimer = () => {
    setResendAvailable(false);
    setTimer(60);
    const interval = setInterval(() => {
      setTimer((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          setResendAvailable(true);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };

  useEffect(() => {
    if (token && user && region?.id) {
      navigate("/dashboard");
    }
  }, [token, user, region, navigate]);

  const handleLogin = async () => {
    setLoading(true);
    try {
      const { token,is2faEnabled,userType } = await login({ username, password });

      if (token) {
        // eslint-disable-next-line
           if(is2faEnabled === true){
                setTempToken(token);
                setShowOTPForm(true);
                toast.success("OTP sent to your registered email");
                startTimer();
                }else{
        
                     try {
        
                      dispatch(setToken(token));
        
                      const { user } = await getUserDetails(token);
                      dispatch(setUser(user));
               
                      if(userType !== '4'){
                      const currentRegion = await api.resellerType.getCurrentRegion({}, token);
                      if (currentRegion.data?.reseller_region_id) {
                        const regioninfo = {
                          id: currentRegion.data.reseller_region_id,
                          name: currentRegion.data.reseller_regionname,
                          currency: currentRegion.data.currency
                        };
                        dispatch(setRegion(regioninfo));
                        dispatch(setSwitchRegion(true));
                      }
                     }
        
                      navigate("/dashboard");
                    } catch (error) {
                      
                    }
                  
        
                   navigate("/dashboard");
                }
        
        
      } else {
        toast.error("Login failed! Please check your credentials.");
      }
    } catch (error) {
      toast.error("Login failed! Please check your credentials.");
    } finally {
      setLoading(false);
    }
  };

  const handleLoginSubmit = async (e) => {
    e.preventDefault();
    await handleLogin();
  };

  const handleResendOTP = async (e) => {
    e.preventDefault();

    if (resendAttempts >= 2) {
    toast.error("You have reached the maximum number of OTP resend attempts.");
    return;
    }


    if (!username || !password) {
      toast.error("Username and password are required to resend OTP.");
      return;
    }

     const resendOtp = await api.users.resend2FA({}, tempToken);
     if(resendOtp.status === true){
       toast.success("OTP sent to your registered email.");
       setResendAttempts((prev) => prev + 1); 
       startTimer();
     }else{
       toast.error("OTP Re sent failed.");
     }
    // await handleLogin();
  };

  const handleOTPSubmit = async (e) => {
    e.preventDefault();
    try {
      // Placeholder: Replace this with actual OTP verification API if needed
      const verifyOtp = await api.users.verify2FA({otp}, tempToken);
      if(verifyOtp.status === true){
      dispatch(setToken(verifyOtp.token));
      const { user } = await getUserDetails(verifyOtp.token);
      dispatch(setUser(user));

      if(user.userType !== 4){
      const currentRegion = await api.resellerType.getCurrentRegion({}, verifyOtp.token);
      if (currentRegion.data?.reseller_region_id) {
        const regioninfo = {
          id: currentRegion.data.reseller_region_id,
          name: currentRegion.data.reseller_regionname,
          currency: currentRegion.data.currency
        };
        dispatch(setRegion(regioninfo));
        dispatch(setSwitchRegion(true));
      }
      }

      navigate("/dashboard");
      }else{
        toast.error("OTP verification failed.");
      }
    } catch (error) {
      toast.error("OTP verification failed.");
    }
  };

  return (
    <div className="container">
      <div className="login-main">
        <div className="card">
          <div className="welcome">
            {showOTPForm ? (
              <>
               <p>Verify OTP to continue to Nodwin.</p>
              </>
              ) : (
              <>
               <h5>Welcome Back !</h5>
               <p>Sign in to continue to Nodwin.</p>
              </>
              )}

          </div>
          <div className="card-body">
            <img className="login-logo" src={LoginImage} alt="login-logo" />

            {showOTPForm ? (
              <form onSubmit={handleOTPSubmit}>
                <div className="mb-3">
                  <label htmlFor="otp" className="form-label">Enter OTP</label>
                  <input
                    type="text"
                    className="form-control"
                    id="otp"
                    value={otp}
                    onChange={(e) => setOtp(e.target.value)}
                    required
                  />
                </div>

                <button type="submit" className="login-btn1 btn mt-3" disabled={loading}>
                  {loading ? "Verifying..." : "Verify OTP"}
                </button>

                <div className="text-center mt-3">
                  {resendAttempts >= 2 ? (
                    <span className="text-danger">Maximum OTP resend attempts reached.</span>
                  ) : !resendAvailable ? (
                    <span className="text-muted">Resend OTP in {timer}s</span>
                  ) : (
                    <span
                      style={{ cursor: "pointer", color: "#007bff" }}
                      onClick={handleResendOTP}
                    >
                      Resend OTP
                    </span>
                  )}
                </div>



              </form>
            ) : (
              <form onSubmit={handleLoginSubmit}>
                <div className="mb-3">
                  <label htmlFor="username" className="form-label">Username</label>
                  <input
                    type="text"
                    className="form-control"
                    id="username"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    required
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="password" className="form-label">Password</label>
                  <input
                    type="password"
                    className="form-control"
                    id="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                </div>
                <div className="form-group">
                  <div className="custom-control custom-checkbox">
                    <input
                      type="checkbox"
                      id="customControlInline"
                      className="custom-control-input"
                    />
                    <label
                      htmlFor="customControlInline"
                      className="custom-control-label"
                    >
                      Remember me
                    </label>
                  </div>
                </div>
                <button type="submit" className="login-btn1 btn mt-3" disabled={loading}>
                  {loading ? "Logging in..." : "Login"}
                </button>
                <div className="text-center">
                  <Link to="/register">
                    <i className="bx bxs-user"></i> Register
                  </Link>
                </div>
                <div className="forgot text-center">
                  <Link to="/forgot">
                    <i className="bx bxs-lock"></i> Forgot your password?
                  </Link>
                </div>
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginForm;
